__turbopack_context__.v({
  "container": "styles-module__kQQ5EW__container",
  "container--collapsed": "styles-module__kQQ5EW__container--collapsed",
  "container--expanded": "styles-module__kQQ5EW__container--expanded",
  "link": "styles-module__kQQ5EW__link",
  "showMoreButton": "styles-module__kQQ5EW__showMoreButton",
  "showMoreButton--collapsed": "styles-module__kQQ5EW__showMoreButton--collapsed",
  "showMoreButton--expanded": "styles-module__kQQ5EW__showMoreButton--expanded",
  "showMoreContainer": "styles-module__kQQ5EW__showMoreContainer",
  "textWrapper": "styles-module__kQQ5EW__textWrapper",
  "textWrapper--collapsed": "styles-module__kQQ5EW__textWrapper--collapsed",
});
